import { render } from "./DojoReportsView.vue?vue&type=template&id=f474e3ac&scoped=true"
import script from "./DojoReportsView.vue?vue&type=script&lang=js"
export * from "./DojoReportsView.vue?vue&type=script&lang=js"

import "./DojoReportsView.vue?vue&type=style&index=0&id=f474e3ac&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f474e3ac"]])

export default __exports__